import React, { useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { BaseDropdown, BaseForm } from "react-epharma-components/lib";
import helpers from "@helpers";

const CrudForm: React.FC = (props) => {
  const benefit = useRef<BaseDropdown>(null);
  const formRef = useRef<BaseForm>(null);

  const inputRefs = [benefit];

  return (
    <BaseForm refs={inputRefs} ref={formRef} {...props}>
      <Row>
        <Col xs={12}>
          <BaseDropdown name="benefitId" mapping="benefitId" label="Benefício" type="number" labelProperty="name" valueProperty="id" endpoint={helpers.endpoints.benefit} ref={benefit} identifier required />
        </Col>
      </Row>
    </BaseForm>
  );
};

export default CrudForm;
